// components/StyledCheckbox.js
import React from 'react';

export default function StyledCheckbox({ checked, onChange, ...props }) {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      style={{
        width: '1.15rem',
        height: '1.15rem',
        accentColor: 'var(--accent-color)',
        cursor: 'pointer',
      }}
      {...props}
    />
  );
}
